/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcription_ProcessingInputs */



/**
* | output |
* | --- |
* | "Transcribing... please wait" |
*
* @param {Transcription_ProcessingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_processing = /** @type {((inputs?: Transcription_ProcessingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_ProcessingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcribing... please wait")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transcribing... please wait")
	if (locale === "it") return /** @type {LocalizedString} */ ("Transcribing... please wait")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Transcribing... please wait")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcribing... please wait")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Transcribing... please wait")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Transcribing... please wait")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Transcribing... please wait")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcribing... please wait")
	return /** @type {LocalizedString} */ ("Transcribing... please wait")
});